<main>
  <div id="print_section" #printSection>
    <order-ticket
      [isDownloading]=isDownloading
      [id]="'Ticket ' + ticket.id"
      *ngFor="let ticket of pageTickets; index as i"
      [data]="prepareData(ticket)"
    ></order-ticket>
  </div>
</main>
